import React, {useState, useEffect} from 'react';
import {Grid , Chip, ListItem, ListItemIcon, ListItemText, Divider, MuiThemeProvider, Tooltip} from '@material-ui/core/';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import {Filter1, Today, LocationOn, } from '@material-ui/icons';
import {functions} from 'constants/index'
import { createMuiTheme } from "@material-ui/core/styles";

function DatosCiudadano(props) {   
    const classes = useStyles()
    const theme = createMuiTheme({
        overrides: {
          MuiTooltip: {
            tooltip: {
              fontSize: "1rem",
              color: "white",
              backgroundColor: "#205690",
              borderRadius: 10,
              padding: '1rem',
              fontWeight: 'bold',
              textTransform: 'uppercase',
              textAlign: 'center'
            }
          }
        }
      });

    return (
        <Grid container >
            <Grid item xs={12}>
                <div className={classes.centerTitle}><Divider /> <strong>RESIDENCIA ENVIADA DEL RENAP DEL EXTRANJERO</strong> <Divider /></div>
            </Grid >
                <Grid item xs={3}>
                    <ListItem className={classes.rootListItem}>
                        <ListItemText className={classes.rootListItemText} primary="SOLICITUD NO.: " />
                        <ListItemIcon className={classes.colorIcon}><LocationOn/></ListItemIcon>
                    </ListItem>
                </Grid >
                <Grid item xs={3}>
                    <Chip variant="outlined" className={classes.colorChip} label={props.datosResidenciaExtranjeroRenapSeleccionado?.idSolicitud} />
                </Grid >
                <Grid item xs={3}>
                    <ListItem className={classes.rootListItem}>
                        <ListItemText className={classes.rootListItemText} primary="CUI DEL DPI: " />
                        <ListItemIcon className={classes.colorIcon}><Today/></ListItemIcon>
                    </ListItem>
                </Grid >
                <Grid item xs={3}>
                    <Chip variant="outlined" className={classes.colorChip} label={props.datosResidenciaExtranjeroRenapSeleccionado?.cui} />
                </Grid >
                <Grid item xs={3}>
                    <ListItem className={classes.rootListItem}>
                        <ListItemText className={classes.rootListItemText} primary="PAIS: " />
                        <ListItemIcon className={classes.colorIcon}><Filter1/></ListItemIcon>
                    </ListItem>
                </Grid >
                <Grid item xs={3}>
                    <Chip variant="outlined" className={classes.colorChip} label={props.datosResidenciaExtranjeroRenapSeleccionado?.paisResidencia?.name} />
                </Grid >
                <Grid item xs={3}>
                    <ListItem className={classes.rootListItem}>
                        <ListItemText className={classes.rootListItemText} primary="ESTADO: " />
                        <ListItemIcon className={classes.colorIcon}><LocationOn/></ListItemIcon>
                    </ListItem>
                </Grid >
                <Grid item xs={3}>
                    <Chip variant="outlined" className={classes.colorChip} label={props.datosResidenciaExtranjeroRenapSeleccionado?.estadoResidencia?.name} />
                </Grid >
                <Grid item xs={3}>
                    <ListItem className={classes.rootListItem}>
                        <ListItemText className={classes.rootListItemText} primary="CIUDAD: " />
                        <ListItemIcon className={classes.colorIcon}><Filter1/></ListItemIcon>
                    </ListItem>
                </Grid >
                <Grid item xs={3}>
                    <Chip variant="outlined" className={classes.colorChip} label={props.datosResidenciaExtranjeroRenapSeleccionado?.ciudadResidencia?.name} />
                </Grid >
            <Grid item xs={12}>
                <div className={classes.centerTitle}><Divider /> <strong>RESIDENCIA ELECTORAL ASIGNADA TSE</strong> <Divider /></div>
            </Grid >
                <Grid item xs={3}>
                    <ListItem className={classes.rootListItem}>
                        <ListItemText className={classes.rootListItemText} primary="PAIS: " />
                        <ListItemIcon className={classes.colorIcon}><Filter1/></ListItemIcon>
                    </ListItem>
                </Grid >                
                <Grid item xs={3}>
                    <Chip variant="outlined" className={classes.colorChip} label={props.data?.pais?.name} />
                </Grid >                
                <Grid item xs={3}>
                    <ListItem className={classes.rootListItem}>
                        <ListItemText className={classes.rootListItemText} primary="ESTADO: " />
                        <ListItemIcon className={classes.colorIcon}><LocationOn/></ListItemIcon>
                    </ListItem>
                </Grid >                
                <Grid item xs={3}>
                    <Chip variant="outlined" className={classes.colorChip} label={props.data?.estado?.name} />
                </Grid >                
                <Grid item xs={3}>
                    <ListItem className={classes.rootListItem}>
                        <ListItemText className={classes.rootListItemText} primary="CIUDAD: " />
                        <ListItemIcon className={classes.colorIcon}><Filter1/></ListItemIcon>
                    </ListItem>
                </Grid >                
                <Grid item xs={3}>
                    <Chip variant="outlined" className={classes.colorChip} label={props.data?.ciudad?.name} />
                </Grid >              
        </Grid>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(DatosCiudadano);